import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: "POST",
          headers: { "X-Session-ID": sessionId },
          credentials: "include",
        });
        if (!res.ok) throw new Error("auth failed");
        const data = await res.json();
        window.history.replaceState({}, document.title, window.location.pathname);
        setSession(data.token, data.user);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google");
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg gap-6">
      <Logo size="lg" />
      <div className="flex items-center gap-3 text-muted">
        <Loader2 className="animate-spin text-cyber" size={20} />
        <span className="font-mono text-sm">Establishing secure session…</span>
      </div>
    </div>
  );
}
